import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {TextField} from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

export function TestModeSection({loader, deleteTestMessage, allowUpdateTestMode, updateTestToggle, testMode, testNumber, updateTestNumber, setTestNumber}) {
    return (<>
            {loader ? <CircularProgress size={25}/> : <DeleteOutlinedIcon onClick={deleteTestMessage} fontSize="large"/>}
            <FormControlLabel labelPlacement="top" disabled={!allowUpdateTestMode} rtl sx={{marginTop: "30px", '& .MuiFormControlLabel-label.Mui-disabled': { color: '#fff' } }}
                              control={<Switch
                                  onClick={updateTestToggle}
                                  checked={testMode}/>}
                              label="מצב בדיקות"/>
            {testMode && <TextField type={"number"} disabled={!allowUpdateTestMode} value={testNumber}
                                    onBlur={updateTestNumber} onChange={(e)=>setTestNumber(e.target.value)}
                                    id="outlined-basic" label="טלפון"
                                    variant="outlined" sx={{'& .MuiInputBase-input': { color: 'your_custom_color_here' }}}/>}
        </>);
}

